'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _episodes = require('./episodes.html');

var _episodes2 = _interopRequireDefault(_episodes);

var _episodes3 = require('./episodes.controller');

var _episodes4 = _interopRequireDefault(_episodes3);

require('./episodes.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodesComponent = {
  restrict: 'E',
  bindings: {},
  template: _episodes2.default,
  controller: _episodes4.default,
  controllerAs: 'vm'
};

exports.default = episodesComponent;


// WEBPACK FOOTER //
// ./client/app/common/admin/episodes/episodes.component.js